import { render, staticRenderFns } from "./RolesPermisos.vue?vue&type=template&id=5abb4a40&scoped=true"
import script from "./RolesPermisos.vue?vue&type=script&lang=js"
export * from "./RolesPermisos.vue?vue&type=script&lang=js"
import style0 from "./RolesPermisos.vue?vue&type=style&index=0&id=5abb4a40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abb4a40",
  null
  
)

export default component.exports